var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contents-area"},[_c('PriceActiveTabs',{attrs:{"activeTab":_vm.activeCategory},on:{"changeActiveTab":_vm.changeActiveTab}}),_vm._v(" "),_c('div',{staticClass:"price-list"},[_c('PriceBookList',{attrs:{"priceBookList":_vm.priceList}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f2d608d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/priceList/Home.vue
// module id = 495
// module chunks = 0